{
  "accountLandingLinkTo": "Compte",
  "accountLandingTitle": "Paramètres du compte",
  "accountSettingsTitle": "Paramètres du compte",
  "activeFarmTitle": "Ferme en activité",
  "adminModeToggle": "Mode administrateur",
  "adminUser": "Utilisateur administrateur",
  "adminUserIndicatorWithEmail": "{{email}} (utilisateur administrateur)",
  "appInfoClearCache": "Vider le cache",
  "appInfoExpireFarmCache": "Actualiser le cache des données de la ferme",
  "appInfoExpireFarmCacheSuccess": "Cache des données de la ferme actualisé",
  "appInfoIsDemoModeActive": "Mode démo activé",
  "appInfoLinkTo": "Informations sur l'application",
  "appInfoTitle": "Informations sur l'application",
  "appInfoUpdateId": "Mettre à jour l'ID",
  "appInfoVersion": "Version",
  "appNotificationsLinkTo": "Annonces",
  "appNotificationsListEmpty": "Aucune annonce pour le moment. Revenez plus tard.",
  "appNotificationsTitle": "Annonces",
  "appPreferences": "Préférences de l'application",
  "changeFarmsListActiveDevicesWithItemCount": "{{itemCount}} appareils actifs",
  "changeFarmsListListEmpty": "Votre compte n'est lié à aucune ferme active.",
  "changeFarmsListSubheaderwithFarmName": "Ferme active : {{farmName}}",
  "changeFarmsListTitle": "Vos comptes agricoles",
  "checkForUpdatesButtonText": "Rechercher des mises à jour",
  "checkForUpdatesError": "Erreur lors de la récupération de la dernière mise à jour de l'application",
  "yourAppIsUpToDate": "Votre application est à jour",
  "checkForUpdatesYourAppIsUpToDate": "Votre application est à jour",
  "companySectionTitle": "À propos de nous",
  "contactUsLink": "Contactez-nous",
  "crashButton": "Accident",
  "darkModeToggle": "Mode sombre",
  "farmJoinCodeTitle": "Code d'adhésion à la ferme",
  "farmUsersListLink": "Utilisateurs agricoles",
  "internalOnlySectionTitle": "Interne uniquement",
  "linkTo": "Compte",
  "measurementPreferenceLabel": "Mesures",
  "measurementPreferenceValues": {
    "metric": "Métrique",
    "us": "USA."
  },
  "nameFirstInputLabel": "Prénom",
  "nameFirstInputPlaceholder": "(Entrez votre prénom)",
  "nameLastInputLabel": "Nom de famille",
  "nameLastInputPlaceholder": "(Entrez votre nom de famille)",
  "newFarmAccount": "Nouveau compte agricole",
  "phoneNumbersListLink": "Numéros de téléphone",
  "shareFeedbackLink": "Partager vos commentaires",
  "supportedLanguages": {
    "en": "🇫🇷 Anglais (États-Unis)",
    "es": "🇲🇽 Espagnol (MX)",
    "fr": "🇫🇷 Français",
    "it": "🇮🇹 Italien"
  },
  "supportedLanguagesTitle": "Langue préférée",
  "userAccountTitle": "Mon compte",
  "userFarmsListLinkTo": "Vos comptes agricoles",
  "userFarmsListListEmpty": "Votre compte n'est lié à aucune ferme active.",
  "userFarmsListNoOtherFarms": "Votre compte n'est lié à aucune autre ferme",
  "userFarmsListSubheaderWithActiveFarmName": "Ferme active : {{activeFarmName}}",
  "userFarmsListTitle": "Vos comptes agricoles",
  "userNameFormCollectionDisclaimer": "Nous recueillons ces informations afin de savoir qui sont nos clients et de fournir la meilleure expérience de service client possible. Nous ne partageons pas ces informations avec des tiers.",
  "userNameFormCollectionTitle": "Collecte de données : nom d'utilisateur",
  "userNameFormInstructions": "Afin de fournir la meilleure expérience de service client possible, nous avons besoin de certaines informations de votre part :",
  "userNameFormTitle": "Nom d'utilisateur",
  "userNameWithNameGivenAndNameFamily": "{{nameGiven}} {{nameFamily}}",
  "viewDebugInfoButton": "Afficher les informations de débogage",
  "viewFarmUserPermissionsLinkTo": "Afficher vos autorisations",
  "viewFarmUserPermissionsTitle": "Vos autorisations",
  "viewPrivacyPolicyLinkTo": "Voir la politique de confidentialité",
  "viewPrivacyPolicyTitle": "politique de confidentialité",
  "deleteAccountLinkTo": "Supprimer le compte",
  "deleteAccountTitle": "Supprimer le compte",
  "deleteAccountWarning": "Cette action est permanente et irréversible. Votre compte sera désactivé, vos informations personnelles seront supprimées et vous serez déconnecté.",
  "deleteAccountConfirmationLabel": "Tapez DELETE pour confirmer",
  "deleteAccountConfirmationPlaceholder": "DELETE",
  "deleteAccountConfirmButton": "Supprimer mon compte",
  "deleteAccountOwnedFarmsWarning": "Vous devez transférer la propriété ou désactiver les fermes suivantes avant de supprimer votre compte :",
  "transferOwnershipLinkTo": "Transférer la propriété",
  "transferOwnershipTitle": "Transférer la propriété de la ferme",
  "transferOwnershipDescription": "Sélectionnez un membre de la ferme pour devenir le nouveau propriétaire.",
  "transferOwnershipSuccess": "Propriété transférée avec succès.",
  "deactivateFarmLinkTo": "Désactiver la ferme",
  "deactivateFarmTitle": "Désactiver la ferme",
  "deactivateFarmWarning": "Cela désactivera la ferme, supprimera l'accès de tous les membres et libérera tous les appareils.",
  "deactivateFarmConfirmButton": "Désactiver la ferme",
  "leaveFarmLinkTo": "Quitter la ferme",
  "leaveFarmConfirmMessage": "Êtes-vous sûr de vouloir quitter cette ferme ?",
  "leaveFarmConfirmButton": "Quitter la ferme"
}
